import { assertNotNull } from '../../helpers/nullHelpers';
import { TechnologyTypeCode } from '../shared/technologyTypeCode';
import { BillOfMaterialsOptionalExtraFormModel } from './billOfMaterialsOptionalExtraFormModel';
import { UnderfloorHeatingOptionTypeCode } from './dataForEditBillOfMaterialsForm';

export type CreateUpdateBillOfMaterialsOptionalExtraDto = {
  billOfMaterialsOptionalExtraId: number | null;
  technologyTypeCode: TechnologyTypeCode;
  underfloorHeatingOptionTypeCode: UnderfloorHeatingOptionTypeCode | null;
  partId: number;
  quantity: number;
};

export const mapBillOfMaterialsOptionalExtraFormModelToDto = (
  formModel: BillOfMaterialsOptionalExtraFormModel,
  technologyTypeCode: TechnologyTypeCode,
  underfloorHeatingOptionTypeCode: UnderfloorHeatingOptionTypeCode | null,
): CreateUpdateBillOfMaterialsOptionalExtraDto => ({
  billOfMaterialsOptionalExtraId: formModel.billOfMaterialsOptionalExtraId,
  technologyTypeCode,
  underfloorHeatingOptionTypeCode,
  partId: assertNotNull(formModel.partId),
  quantity: Number(formModel.quantity),
});
